module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-row', [_c('div', {
    staticClass: "top1",
    staticStyle: {
      "background-color": "#FFF",
      "border-bottom": "solid 1px #E5E5E5"
    }
  }, [_c('div', {
    staticClass: "top_1"
  }, [_c('div', {
    staticClass: "top_1_1"
  }, [_c('a', {
    staticClass: "changehands",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.showWechatImg()
      }
    }
  }, [_vm._v("关注微信")])]), _vm._v(" "), _c('div', {
    staticClass: "top_1_2"
  }, [_c('ul', {
    attrs: {
      "id": "sddm"
    }
  }, [_c('li', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("客服电话：029-68892595")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("管理登录")])])])])])])]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "width": "70%",
      "margin": "0 auto"
    }
  }, [_c('el-row', [_c('el-row', [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": "/MyBill",
      "mode": "horizontal",
      "background-color": "#545c64",
      "text-color": "#fff",
      "active-text-color": "#ffd04b"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/MyBill"
    }
  }, [_vm._v("新生缴费")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/MyBillHistory"
    }
  }, [_vm._v("新生缴费历史")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/Print"
    }
  }, [_vm._v("打印报道单")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/Exit"
    }
  }, [_vm._v("退出")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.infoVisible),
      expression: "infoVisible"
    }],
    staticClass: "back-up",
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_vm._v("提示")]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "height": "60px",
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v(_vm._s(_vm.info))])])], 1), _vm._v(" "), _c('el-row', [_c('BigImg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showImg),
      expression: "showImg"
    }],
    staticStyle: {
      "z-index": "1001"
    },
    attrs: {
      "imgSrc": _vm.imgSrc
    },
    on: {
      "click": function($event) {
        _vm.viewImg()
      }
    }
  })], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chooseDormVisible),
      expression: "chooseDormVisible"
    }]
  }, [_c('el-row', {
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('el-row', {
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('el-form', {
    ref: "dormSetForm",
    staticStyle: {
      "width": "50%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "model": _vm.dormSetForm,
      "label-width": "90px"
    }
  }, [_c('el-row', [_c('img', {
    staticClass: "banner-img",
    staticStyle: {
      "width": "50%",
      "height": "150px",
      "float": "left"
    },
    attrs: {
      "src": _vm.effectDrawing
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "banner-img",
    staticStyle: {
      "width": "50%",
      "height": "150px",
      "float": "right"
    },
    attrs: {
      "src": _vm.bedDiagram
    }
  })]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "收费标准"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.price))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "规格"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.dormStandard))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "宿舍配置"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.roomSet))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "公共配置"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.pubAreaSet))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "所在区域"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.region))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "备注"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.remark))])])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('el-form', {
    ref: "dormChooseForm",
    staticStyle: {
      "width": "50%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "inline": _vm.global.editInline,
      "model": _vm.dormChooseForm,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "公寓"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 ==",
      "disabled": _vm.getDisableEdit('flatsName', 'form')
    },
    model: {
      value: (_vm.dormChooseForm['flatsName']),
      callback: function($$v) {
        _vm.$set(_vm.dormChooseForm, 'flatsName', $$v)
      },
      expression: "dormChooseForm['flatsName']"
    }
  }, _vm._l((_vm.modeSelector('Flats')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "宿舍类型"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 ==",
      "disabled": _vm.getDisableEdit('dormSet', 'form')
    },
    model: {
      value: (_vm.dormChooseForm['dormSet']),
      callback: function($$v) {
        _vm.$set(_vm.dormChooseForm, 'dormSet', $$v)
      },
      expression: "dormChooseForm['dormSet']"
    }
  }, _vm._l((_vm.modeSelector('Dorm_Set')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "宿舍"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 ==",
      "disabled": _vm.getDisableEdit('roomNo', 'form')
    },
    model: {
      value: (_vm.dormChooseForm['roomNo']),
      callback: function($$v) {
        _vm.$set(_vm.dormChooseForm, 'roomNo', $$v)
      },
      expression: "dormChooseForm['roomNo']"
    }
  }, _vm._l((_vm.modeSelector('Room')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "床位"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 ==",
      "disabled": _vm.getDisableEdit('bedNo', 'form')
    },
    model: {
      value: (_vm.dormChooseForm['bedNo']),
      callback: function($$v) {
        _vm.$set(_vm.dormChooseForm, 'bedNo', $$v)
      },
      expression: "dormChooseForm['bedNo']"
    }
  }, _vm._l((_vm.modeSelector('Bed')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('span', {
    staticClass: "deg-title"
  }, [_vm._v("所选床位有效期20分钟 ！！！")])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.nextStep('Dorm')
      }
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chooseOtherVisible),
      expression: "chooseOtherVisible"
    }],
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('el-row', {
    staticClass: "back-up"
  }, [_c('img', {
    staticStyle: {
      "height": "40vh",
      "width": "35vw"
    },
    attrs: {
      "src": _vm.size_Img
    }
  })]), _vm._v(" "), _c('el-row', {
    staticClass: "form_main"
  }, [_c('el-form', {
    ref: "clothChooseForm",
    staticStyle: {
      "width": "50%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "inline": _vm.global.editInline,
      "model": _vm.clothChooseForm,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "迷彩服"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 =="
    },
    model: {
      value: (_vm.clothChooseForm['coatSize']),
      callback: function($$v) {
        _vm.$set(_vm.clothChooseForm, 'coatSize', $$v)
      },
      expression: "clothChooseForm['coatSize']"
    }
  }, _vm._l((_vm.modeSelector('XF_Coat_Size')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeId,
        "value": option.modeId
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "迷彩衫"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 =="
    },
    model: {
      value: (_vm.clothChooseForm['shirtSize']),
      callback: function($$v) {
        _vm.$set(_vm.clothChooseForm, 'shirtSize', $$v)
      },
      expression: "clothChooseForm['shirtSize']"
    }
  }, _vm._l((_vm.modeSelector('XF_Shirt_Size')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeId,
        "value": option.modeId
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "鞋子尺码"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 =="
    },
    model: {
      value: (_vm.clothChooseForm['shoesSize']),
      callback: function($$v) {
        _vm.$set(_vm.clothChooseForm, 'shoesSize', $$v)
      },
      expression: "clothChooseForm['shoesSize']"
    }
  }, _vm._l((_vm.modeSelector('XF_Shoes_Size')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeId,
        "value": option.modeId
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.back('07')
      }
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.nextStep('Other')
      }
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.feeListVisible),
      expression: "feeListVisible"
    }],
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('el-row', [_c('el-form', {
    ref: "curStudent",
    staticStyle: {
      "width": "50%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "model": _vm.curStudent,
      "label-width": "90px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "姓名"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.curStudent.studentName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "身份证号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.curStudent.uid))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "专业"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.curStudent.majorMatr))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "学年"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.curStudent.enrollmentYear))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "应缴总额"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Ginkgo.format(_vm.feeSum.payableAmount, 'money')))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "减免总额"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Ginkgo.format(_vm.feeSum.reduceAmount, 'money')))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "实缴总额"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.Ginkgo.format(_vm.feeSum.feeAmount, 'money')))])]), _vm._v(" "), _c('el-collapse', [_c('el-collapse-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "title": "费用明细",
      "name": "1"
    }
  }, [_c('el-row', _vm._l((_vm.feeList), function(item) {
    return _c('div', {
      key: item.feeNo
    }, [_c('span', {
      staticClass: "label_detail"
    }, [_vm._v(_vm._s(item.feeNo))]), _c('span', {
      staticClass: "label_value"
    }, [_vm._v(_vm._s(_vm.Ginkgo.format(item.feeAmount, 'money')))])])
  }))], 1), _vm._v(" "), _c('el-collapse-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "title": "公寓用品明细",
      "name": "2"
    }
  }, [_c('el-row', [_c('div', [_c('span', {
    staticClass: "label_detail"
  }, [_vm._v("6斤棉被")]), _c('span', {
    staticClass: "label_value"
  }, [_vm._v("1床")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "label_detail"
  }, [_vm._v("4斤棉被")]), _c('span', {
    staticClass: "label_value"
  }, [_vm._v("1床")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "label_detail"
  }, [_vm._v("5斤棉褥")]), _c('span', {
    staticClass: "label_value"
  }, [_vm._v("1床")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "label_detail"
  }, [_vm._v("床单")]), _c('span', {
    staticClass: "label_value"
  }, [_vm._v("2条")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "label_detail"
  }, [_vm._v("被套")]), _c('span', {
    staticClass: "label_value"
  }, [_vm._v("2床")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "label_detail"
  }, [_vm._v("枕巾")]), _c('span', {
    staticClass: "label_value"
  }, [_vm._v("1条")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "label_detail"
  }, [_vm._v("枕套")]), _c('span', {
    staticClass: "label_value"
  }, [_vm._v("1个")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "label_detail"
  }, [_vm._v("枕芯")]), _c('span', {
    staticClass: "label_value"
  }, [_vm._v("1个")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "label_detail"
  }, [_vm._v("暖水瓶")]), _c('span', {
    staticClass: "label_value"
  }, [_vm._v("1个")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "label_detail"
  }, [_vm._v("脸盆")]), _c('span', {
    staticClass: "label_value"
  }, [_vm._v("2个")])])])], 1), _vm._v(" "), _c('el-collapse-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "title": "军训用品明细",
      "name": "3"
    }
  }, [_c('el-row', [_c('div', [_c('span', {
    staticClass: "label_detail"
  }, [_vm._v("迷彩服")]), _c('span', {
    staticClass: "label_value"
  }, [_vm._v("1套")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "label_detail"
  }, [_vm._v("迷彩衫")]), _c('span', {
    staticClass: "label_value"
  }, [_vm._v("1件")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "label_detail"
  }, [_vm._v("军帽")]), _c('span', {
    staticClass: "label_value"
  }, [_vm._v("1顶")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "label_detail"
  }, [_vm._v("军鞋")]), _c('span', {
    staticClass: "label_value"
  }, [_vm._v("1双")])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "label_detail"
  }, [_vm._v("马扎")]), _c('span', {
    staticClass: "label_value"
  }, [_vm._v("1个")])])])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('span', {
    staticClass: "deg-title"
  }, [_vm._v("所选床位即将失效，请尽快支付 ！！！")])])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.back('08')
      }
    }
  }, [_vm._v("上一步")]), _vm._v(" "), (_vm.feePayType_UN) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.toPay()
      }
    }
  }, [_vm._v("银联支付")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.feeListHistoryVisible),
      expression: "feeListHistoryVisible"
    }]
  }, [_c('el-table', {
    ref: "resultTable",
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.tableData,
      "highlight-current-row": "",
      "stripe": "",
      "border": "",
      "height": _vm.global.tableHeight
    },
    on: {
      "sort-change": _vm.handleSortChangeHistory
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "fixed": "",
      "width": "60"
    }
  }), _vm._v(" "), _vm._l((_vm.getUISetQueryResult('01')), function(item) {
    return (_vm.getHeaderVisible(item, 1)) ? _c('el-table-column', {
      key: item.columnName,
      attrs: {
        "prop": item.columnProp,
        "label": item.columnDesc.split('|')[0],
        "min-width": item.colWidth,
        "align": item.alignType,
        "formatter": _vm.dataFormatHistory,
        "fixed": _vm.Ginkgo.getColumnFixed(item),
        "sortable": "custom",
        "header-align": "center"
      }
    }, _vm._l((_vm.getHeaderGroup(item, 2, '01')), function(item2) {
      return (_vm.getHeaderVisible(item2, 2)) ? _c('el-table-column', {
        key: item2.columnName,
        attrs: {
          "prop": item2.columnProp,
          "label": item2.columnDesc.split('|')[1],
          "min-width": item2.colWidth,
          "align": item2.alignType,
          "formatter": _vm.dataFormatHistory,
          "fixed": _vm.Ginkgo.getColumnFixed(item2),
          "sortable": "custom",
          "header-align": "center"
        }
      }, _vm._l((_vm.getHeaderGroup(item2, 3, '01')), function(item3) {
        return (_vm.getHeaderVisible(item3, 3)) ? _c('el-table-column', {
          key: item3.columnName,
          attrs: {
            "prop": item3.columnProp,
            "label": item3.columnDesc.split('|')[2],
            "min-width": item3.colWidth,
            "align": item3.alignType,
            "formatter": _vm.dataFormatHistory,
            "fixed": _vm.Ginkgo.getColumnFixed(item3),
            "sortable": "custom",
            "header-align": "center"
          }
        }) : _vm._e()
      })) : _vm._e()
    })) : _vm._e()
  })], 2), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "current-page": _vm.page.number + 1,
      "page-sizes": _vm.page.pageSizes,
      "page-size": _vm.page.size,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.page.totalElements,
      "page-count": _vm.page.totalPages
    },
    on: {
      "size-change": _vm.handleSizeChangeHistory,
      "current-change": _vm.handleCurrentChangeHistory
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c1ac69c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/XiFan/MyBillXiFanNew.vue
// module id = 1132
// module chunks = 1